import {isNilOrEmpty} from 'ramda-adjunct';

import {useListThemeQuery} from '@dms/api/core';
import {getWorkspaceFromUri, urlBuilder, UrlBuilderConfig} from '@dms/routes';
import {createSearchParamsString} from '@dms/shared';

import {useWorkspaceLanguage} from './useWorkspaceLanguage';

const DUMMY_URL = 'https://www.example.com';

export const useCertificateLink = (inspectionId?: string) => {
  const {workspace} = getWorkspaceFromUri();
  const workspaceLanguage = useWorkspaceLanguage();
  const {data: themes} = useListThemeQuery();

  const getLink = () => {
    if (isNilOrEmpty(inspectionId)) {
      return DUMMY_URL;
    }

    const builderConfig: UrlBuilderConfig = {
      workspace,
      protocol: window.location.protocol,
      domain: process.env.DIGITAL_CERTIFICATE_DOMAIN!,
      route: `/${inspectionId}`,
      searchParam: createSearchParamsString({
        lang: workspaceLanguage,
        theme: themes?.[0]?.themeId,
      }),
    };

    return urlBuilder(builderConfig);
  };

  return [getLink];
};
